import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const Hero = () => (
    <motion.div
        id="hero"
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
    >
        <motion.h2 className="hero-text">Bring SOLE to Your Campus</motion.h2>
        <p className="hero-subtext">
            Start a chapter of Servants of Our Lady of Evangelization and join a
            27-year tradition of clear, charitable Catholic evangelization.
        </p>
    </motion.div>
);

const WhyStart = () => (
    <section className="section section-light sole-info" id="why-start">
        <div className="section-inner">
            <h2>Why Start a Chapter?</h2>
            <p>
                SOLE equips students to defend and share the Catholic faith with charity
                and clarity. A chapter creates a visible, joyful witness on campus and a
                place for real formation, conversation, and mission.
            </p>
            <ul>
                <li>Make disciples on your campus through confident evangelization.</li>
                <li>Form students in apologetics, catechesis, and prayer.</li>
                <li>Join a national network with mentorship and shared resources.</li>
            </ul>
        </div>
    </section>
);

const WhatItLooksLike = () => (
    <motion.section
        className="section section-dark"
        id="what-it-looks-like"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
    >
        <div className="section-inner">
            <h2>What a Chapter Looks Like</h2>
            <ul>
                <li>
                    <strong>Weekly Meetings:</strong> 20‑minute apologetics talk followed by
                    Q&A and discussion.
                </li>
                <li>
                    <strong>Outreach:</strong> Tabling with the sign “I’m a Catholic, ask me
                    questions.”
                </li>
                <li>
                    <strong>Media:</strong> Short reels and posts that invite conversation.
                </li>
                <li>
                    <strong>Community:</strong> Prayer, study, and friendship anchored in the
                    life of the Church.
                </li>
            </ul>
        </div>
    </motion.section>
);

const WhatWeProvide = () => (
    <section className="section section-light" id="what-we-provide">
        <div className="section-inner">
            <h2>What We Provide</h2>
            <ul>
                <li>Leader training and ongoing mentorship.</li>
                <li>Talk outlines, slides, and Catholic Defense Hub access.</li>
                <li>Brand kit: logos, templates, and merch guidance.</li>
                <li>Fundraising tips and simple launch playbooks.</li>
            </ul>
        </div>
    </section>
);

const Steps = () => (
    <motion.section
        className="section section-dark"
        id="steps"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
    >
        <div className="section-inner">
            <h2>How to Start</h2>
            <ol>
                <li>
                    <strong>Pray & Discern:</strong> Ask Our Lady’s guidance for your campus.
                </li>
                <li>
                    <strong>Gather a Core Team:</strong> 2–3 committed students to begin.
                </li>
                <li>
                    <strong>Connect with Us:</strong> Fill out the interest form so we can
                    support you.
                </li>
                <li>
                    <strong>Obtain Local Approval:</strong> Work with your chaplain/campus
                    ministry; we’ll help with the process.
                </li>
                <li>
                    <strong>Launch:</strong> Use the SOLE Starter Kit for your first talk and
                    outreach day.
                </li>
            </ol>
        </div>
    </motion.section>
);

const FAQ = () => (
    <section className="section section-dark" id="faq">
        <div className="section-inner">
            <h2>FAQ</h2>
            <h3>Do I need permission from campus ministry?</h3>
            <p>
                Yes. We encourage collaboration with your chaplain and Catholic center.
                We’ll provide a simple brief you can share to explain SOLE’s mission.
            </p>
            <h3>What if my school doesn’t have a Catholic center?</h3>
            <p>
                You can still register a student organization and find a local priest to
                advise. We’ll help you navigate it.
            </p>
            <h3>Do leaders have to be theology experts?</h3>
            <p>
                No. You need docility to the Church and a willingness to learn. Our
                resources will equip you.
            </p>
        </div>
    </section>
);


const CTA = () => (
    <section className="section section-light subscribe-contact-cta" id="start-now">
        <div className="section-inner">
            <h2>Ready to Start?</h2>
            <p>Tell us about your campus and we’ll help you launch.</p>
            <div
                className="cta-buttons"
                style={{ display: "flex", flexDirection: "column", gap: "1rem", justifyContent: "center", marginTop: "1rem" }}
            >
                <Link to="/start-chapter/apply" className="subscribe-button narrow">
                    Start a Chapter
                </Link>
                <Link to="/contact" className="subscribe-button narrow">
                    Talk to Us First
                </Link>
            </div>
        </div>
    </section>
);

const StartChapter = () => (
    <div className="App start-page">
        <Navbar />
        <Hero />
        <WhyStart />
        <WhatItLooksLike />
        <WhatWeProvide />
        <Steps />
        <CTA />
        <FAQ />
        <Footer />
    </div>
);

export default StartChapter;
